import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Polyline, { points: "17 11 12 6 7 11", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Polyline, { points: "17 18 12 13 7 18", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "ChevronsUp";
const ChevronsUp = memo(themed(Icon));
export {
  ChevronsUp
};
//# sourceMappingURL=chevrons-up.js.map
